import { Box, makeStyles, Typography } from "@material-ui/core";
import moment from "moment";
import useDevice from "src/hooks/use-device";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    padding: theme.spacing(1, 0),
    backgroundColor: theme.palette.background.secondary,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
}));

export default function Footer() {
  const cls = useStyles();
  const { isMobile } = useDevice();
  const year = moment().year();

  return (
    <Box id="travanft-footer" className={cls.root}>
      <Typography style={{ order: isMobile ? 3 : 1 }} variant="body2">
        Copyright &copy; {year}. All Rights Reserved By Trava.Finance
      </Typography>
      <Box px={1} height={8} order={2} />
      <a
        href="https://www.dmca.com/Protection/Status.aspx?id=bcd6053a-1dff-4e97-9527-ca9a80a122a4&refurl=https://nft-app.trava.finance/"
        target="_blank"
        rel="noreferrer noopenner"
        title="DMCA.com Protection Status"
        className="dmca-badge"
        style={{ display: "flex", alignItems: "center", order: isMobile ? 1 : 3 }}
      >
        {" "}
        <img
          src="https://images.dmca.com/Badges/dmca_protected_sml_120m.png?ID=bcd6053a-1dff-4e97-9527-ca9a80a122a4"
          alt="DMCA.com Protection Status"
        />
      </a>{" "}
    </Box>
  );
}
